import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productTypes: [],
  departmentList: [],
  categoryList: [],
  salesTaxList: [],
  clientList: [],
  employesList: [],
  clientAddressList: [],
  statusList: [],
  employeesList: [],
  projectTasks: [],
  sourceOfLead: [],
  //vendorsList: [],
  companyNames: [],
  partnerType: [],
  warrantyUnits: [],
  addressProvinces: [],
  addressCountries: [],
  lookupData: {},
  totalItems: {},
  companies: [],
  quoteTypes: [],
  intervals: [],
  addressList: [],
  partnersList: [],
  partnerSubClients: [],
  companyTAndC: null,
  technicians: [],
  emergencyTypes: [],
  projects: [],
};

export const LookupSlice = createSlice({
  name: "lookup",
  initialState,
  reducers: {
    setProductTypes: (state, action) => {
      state.productTypes = action.payload;
    },
    setDepartments: (state, action) => {
      state.departmentList = action.payload;
    },
    setCategories: (state, action) => {
      state.categoryList = action.payload;
    },
    setSalesTax: (state, action) => {
      state.salesTaxList = action.payload;
    },
    setClients: (state, action) => {
      state.clientList = action.payload;
    },
    resetClients: (state, action) => {
      state.clientList = [];
    },
    setEmployes: (state, action) => {
      state.employesList = action.payload;
    },
    setclientAddress: (state, action) => {
      state.clientAddressList = action.payload;
    },
    resetclientAddress: (state, action) => {
      state.clientAddressList = [];
    },
    setStatus: (state, action) => {
      state.statusList = action.payload;
    },
    setEmployees: (state, action) => {
      state.employeesList = action.payload;
    },
    setProjectTasks: (state, action) => {
      state.projectTasks = action.payload;
    },
    // setVendors: (state, action) => {
    //   state.vendorsList = action.payload;
    // },
    setCompanyNames: (state, action) => {
      state.companyNames = action.payload;
    },
    setSourceOfLeads: (state, action) => {
      state.sourceOfLead = action.payload;
    },
    setPartnerType: (state, action) => {
      state.partnerType = action.payload;
    },
    setWarrantyUnits: (state, action) => {
      state.warrantyUnits = action.payload;
    },
    setAddressProvinces: (state, action) => {
      state.addressProvinces = action.payload;
    },
    setAddressCountries: (state, action) => {
      state.addressCountries = action.payload;
    },
    setLookupData: (state, action) => {
      const { lookupType, items } = action.payload;
      state.lookupData[lookupType] = items;
    },
    setTotalItems: (state, action) => {
      const { lookupType, total } = action.payload;
      state.totalItems[lookupType] = total;
    },
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    setQuoteTypes: (state, action) => {
      state.quoteTypes = action.payload;
    },
    setServiceIntervals: (state, action) => {
      state.intervals = action.payload;
    },
    setAddressList: (state, action) => {
      state.addressList = action.payload;
    },
    setPartners: (state, action) => {
      state.partnersList = action.payload;
    },
    resetPartners: (state, action) => {
      state.partnersList = [];
    },
    setPartnerSubClients: (state, action) => {
      state.partnerSubClients = action.payload;
    },
    resetPartnerSubClients: (state, action) => {
      state.partnerSubClients = [];
    },
    setcompanyTAndC: (state, action) => {
      state.companyTAndC = action.payload;
    },
    setTechnicians: (state, action) => {
      state.technicians = action.payload;
    },
    setEmergencyTypes: (state, action) => {
      state.emergencyTypes = action.payload;
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    resetProjects: (state, action) => {
      state.projects = [];
    },
  },
});

export const {
  setProductTypes,
  setDepartments,
  setCategories,
  setSalesTax,
  setClients,
  setEmployes,
  setclientAddress,
  resetclientAddress,
  setStatus,
  setEmployees,
  setProjectTasks,
  setVendors,
  setCompanyNames,
  setSourceOfLeads,
  setPartnerType,
  setWarrantyUnits,
  setAddressProvinces,
  setAddressCountries,
  setLookupData,
  setTotalItems,
  setCompanies,
  setQuoteTypes,
  setServiceIntervals,
  setAddressList,
  resetClients,
  setPartners,
  resetPartners,
  setPartnerSubClients,
  resetPartnerSubClients,
  setcompanyTAndC,
  setTechnicians,
  setEmergencyTypes,
  setProjects,
  resetProjects,
} = LookupSlice.actions;

export default LookupSlice.reducer;
